'use strict'

//var Masonry	= require('./Masonry.js');

function init() {
	$(document).ready(function() {
		function openItem() {
			$('.galleryItem--expandable .image').on('click.expandable', function(event) {
				event.stopPropagation();
				if (event.target.className != 'lightboxTrigger') {
					$(this).parents('.galleryItem--expandable').toggleClass('galleryItem--expanded');
//					Masonry.layout();
				}
			});
			$('.galleryItem--expandable .media__contentInner').on('click.closeItem', function(e) {
				e.stopPropagation();
				$(this).parents('.galleryItem--expandable').removeClass('galleryItem--expanded');
//				Masonry.layout();
			});
		}
		function lightbox() {
			$('.lightboxTrigger').magnificPopup({
				type: 'image',
				image: {
					titleSrc: 'title',
					markup: [
				         // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button
						'<div class="mfp-figure">',
							'<div class="mfp-close"></div>',
							'<div class="mfp-img"></div>',
							'<div class="mfp-bottom-bar">',
								'<div class="mfp-title"></div>',
								'<div class="mfp-counter"></div>',
								'<a title="Previous (Left arrow key)" type="button" class="mfp-arrow mfp-arrow-left mfp-prevent-close"></a>',
								'<a title="Next (Right arrow key)" type="button" class="mfp-arrow mfp-arrow-right mfp-prevent-close"></a>',
							'</div>',
						'</div>'
		            ].join(''), 
					verticalFit: true // Fits image in area vertically
				},
				gallery:{
					enabled:true,
					preload: [0,2], // read about this option in next Lazy-loading section
					tCounter: ''
				},
				callbacks: {
					beforeOpen: function(){
						this.wH = $('.mfp-container').height() - $('.mfp-bottom-bar').outerHeight() - 40;
					},
					open: function() {
						var magnificPopup = $.magnificPopup.instance;
						$('.mfp-arrow-left').on('click', function() {
							magnificPopup.prev();
						});
						$('.mfp-arrow-right').on('click', function() {
							magnificPopup.next();
						});
					}
				},
				mainClass: 'mfp-with-zoom', // this class is for CSS animation below
				overflowY: 'hidden',
				zoom: {
					enabled: false, // By default it's false, so don't forget to enable it
					
					duration: 300, // duration of the effect, in milliseconds
					easing: 'ease-in-out', // CSS transition easing function
					
					// The "opener" function should return the element from which popup will be zoomed in
					// and to which popup will be scaled down
					// By defailt it looks for an image tag:
					opener: function(openerElement) {
						// openerElement is the element on which popup was initialized, in this case its <a> tag
						// you don't need to add "opener" option if this code matches your needs, it's defailt one.
						return openerElement.is('img') ? openerElement : openerElement.find('img');
					}
				}
				,removalDelay: 300
			});
		}
		
		lightbox();
		openItem();
	});
}

var GalleryBox = {
	init: init
};

module.exports = GalleryBox;